export const sort_down = () => (
  <path
    d="M12 5v14m0 0l4-4m-4 4l-4-4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
